import React from 'react'
import { AppBar, Box, Tooltip, Typography } from '@mui/material'
import { useIsEdgeAdmin } from '@edge/spark/io-roles'
import { ExperimentTogglesDialog, MswOverlayPanel } from '../../spark_libs_deprecated/feature-experiment-toggles'
import { env } from '@edge/env'

const buildEnv = process.env.NODE_ENV
const buildNumber = env.REACT_APP_BUILD_NUMBER
const buildTimestamp = env.REACT_APP_BUILD_TIMESTAMP
const branch = env.REACT_APP_BRANCH_NAME

const timeString = buildTimestamp ? new Date(buildTimestamp).toLocaleString('en-US') : ''
const currentYear = new Date().getFullYear()

type FooterDialogs = 'experiments' | null

interface Props {
    footerRef: React.MutableRefObject<HTMLDivElement | null>
}

const Footer: React.VFC<Props> = ({ footerRef }: Props) => {
    const [dialog, setDialog] = React.useState<FooterDialogs>(null)
    const isEdgeAdmin = useIsEdgeAdmin() || true

    const openDialog: React.MouseEventHandler = (event) => {
        if (event.metaKey && isEdgeAdmin) {
            setDialog('experiments')
        }
    }
    const closeDialog = () => setDialog(null)

    return (
        <>
            <ExperimentTogglesDialog open={dialog === 'experiments'} onClose={closeDialog} />
            <MswOverlayPanel />
            <AppBar
                sx={{
                    padding: 1,
                    zIndex: 3,
                }}
                color="primary"
                ref={footerRef}
                component="footer"
                position="relative"
                onClick={openDialog}
            >
                <Typography
                    align="center"
                    sx={{ fontSize: 10, color: 'white', '& span': { mx: 0.5 } }}
                    variant="caption"
                >
                    <span>Copyright © 2019 - {currentYear} Auction Edge.</span>
                    <span>All rights reserved.</span>
                    <Box sx={{ display: { md: 'none' } }} />
                    <span>All trademarks property of their owners.</span>
                    {buildNumber ? <span>Build #{buildNumber}</span> : undefined}
                    {branch ? <span>({branch})</span> : undefined}
                    {timeString ? (
                        <Tooltip title={buildEnv} placement="top-start">
                            <span>Created on: {timeString}</span>
                        </Tooltip>
                    ) : undefined}
                </Typography>
            </AppBar>
        </>
    )
}

export default Footer
